import { saveInCategory, deleteInCategory, takenInCategory } from "./compassLists";
import { CompassItemEditor } from "./CompassItemEditor";

// The editor for a habit or temptation kept in a category, saved on the compass: the Habits and Temptations pages,
// the Goal page's Habits and Radar's Habits open it. `kind` is a COMPASS_KINDS entry; `from` is { categoryId, index }
// for one being changed, or null for a new one, which starts in `initialCategoryId` (and, for a habit, `initialGoalId`).
export function CategoryItemEditor({ kind, categories, goals, from, initialCategoryId = "", initialGoalId = "", setCompass, onClose }) {
  const save = (change) => setCompass(p => ({ ...p, categories: change(p.categories || []) }));
  return (
    <CompassItemEditor kind={kind} categories={categories} goals={goals}
      item={from ? categories.find(c => c.id === from.categoryId)?.[kind.field]?.[from.index] ?? null : null}
      initialCategoryId={from?.categoryId || initialCategoryId} initialGoalId={initialGoalId}
      isTaken={(text, categoryId) => takenInCategory(categories, kind.field, from, categoryId, text)}
      onSave={(item, categoryId) => save(cats => saveInCategory(cats, kind.field, from, categoryId, item))}
      onDelete={() => save(cats => deleteInCategory(cats, kind.field, from))}
      onClose={onClose} />
  );
}
